import Paper from '@material-ui/core/Paper';
import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React, { useMemo, useState } from 'react';
import EnhancedTable from '../../Shared/EnhancedTable/EnhancedTable';
import { tableStyles } from '../CaseDashboard.style';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import RecordDicomsDialog from './RecordDicomsDialog/RecordDicomsDialog';

const combinedStyles = (theme) => ({
  ...tableStyles(theme),
});

const headCells = [
  { id: 'partNumber', label: 'PartNo/RefNo', width: '10%' },
  { id: 'locationName', label: 'Location Name', width: '20%' },
  { id: 'records', label: 'Records', width: '12%' },
];

function ViewButton(props) {
  const { classes, setIsDialogOpen, row, setRecord } = props;

  const viewClickHandler = () => {
    setIsDialogOpen(true);
    setRecord(row);
  };

  return (
    <div className={classes.viewSection}>
      <Button
        variant="contained"
        size="small"
        className={classes.viewBtn}
        onClick={viewClickHandler}
        data-testid="caseRecordViewButton"
      >
        Open
      </Button>
    </div>
  );
}

const DicomStudies = (props) => {
  const {
    classes,
    studies = [],
    isLoading,
    orderId,
    isDownloadAllowed,
    showDicomCdDownload,
  } = props;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [record, setRecord] = useState(null);
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'info', // 'success', 'error', 'warning', 'info'
  });

  const studiesGroupedByPartNumber = useMemo(() => {
    const parts = [];
    for (const study of studies) {
      const part = parts.find((part) => part.partNumber === study.partNumber);
      if (part) {
        part.studies.push(study);
      } else {
        parts.push({
          partNumber: study.partNumber,
          locationName: study.locationName,
          studies: [study],
        });
      }
    }
    return parts;
  }, [studies]);

  const showNotification = (message, severity = 'info') => {
    setNotification({
      open: true,
      message,
      severity,
    });
  };

  const handleCloseNotification = () => {
    setNotification((prev) => ({ ...prev, open: false }));
  };

  const customCells = {
    records: (
      <ViewButton
        classes={classes}
        setIsDialogOpen={setIsDialogOpen}
        setRecord={setRecord}
      />
    ),
  };

  return (
    <div>
      <Paper elevation={0} className={classes.tableTitle}>
        DICOM Studies
      </Paper>
      <EnhancedTable
        rows={studiesGroupedByPartNumber}
        headCells={headCells}
        customCells={customCells}
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
        showPagination
        pageCount={5}
        isLoading={isLoading}
        rowKey="partNumber"
      />

      {isDialogOpen && (
        <RecordDicomsDialog
          open={isDialogOpen}
          setOpen={setIsDialogOpen}
          record={record}
          orderId={orderId}
          showNotification={showNotification}
          isDownloadAllowed={isDownloadAllowed}
          showDicomCdDownload={showDicomCdDownload}
        />
      )}
      
      {/* Notification Snackbar */}
      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={notification.severity}
          variant="filled"
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default withStyles(combinedStyles)(DicomStudies);
